import DataAccess from './constants';
import API from './API'

const path = 'products';
let api = new API(DataAccess.apiUrl, DataAccess.userName, DataAccess.password);

export const apiGetProductsByProductType = (productType) => {
    let newpath = path + "?ProductType=" + productType;
    return api.getData(newpath)
}

export const apiGetProductsByProductTypeAndDisplayArea = (productType, displayArea) => {
    let newpath = path + "?ProductType=" + productType + "&DisplayArea=" + displayArea;
    return api.getData(newpath)
}